import { getFeatureToggleClient } from 'misc/featureToggles'

export default function isTaxAssistantToggleEnabled() {
  return getFeatureToggleClient().variation('Services.LuisAI', false)
}
